import { pick } from '@/lib/utils';
import { EMPTY_COMPANY_PROFILE_FORM } from '../constants/accountSetup.constants';

const FORM_KEYS = Object.keys(EMPTY_COMPANY_PROFILE_FORM);

export const toCompanyProfileForm = (companyProfile) => ({
  ...EMPTY_COMPANY_PROFILE_FORM,
  ...pick(companyProfile ?? {}, FORM_KEYS),
});

export const buildCompanyProfileDto = (values) => ({
  companyName: values.companyName.trim(),
  companyId: values.companyId.trim(),
  addressLine1: values.addressLine1.trim(),
  addressLine2: values.addressLine2.trim(),
  city: values.city.trim(),
  country: values.country.trim(),
  zipCode: values.zipCode.trim(),
});
